import { Badge, ErrorMessage, Heading, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { IControlAttributes } from "../../../../base/models";
import { useHeadingProperties } from "./HeadingProperties";

interface IHeadingComponentProps extends IControlAttributes {
    as: React.ElementType
}

export const DraftHeadingComponent: FC<IHeadingComponentProps> = ({
    as: AsComponent, control, children, designerMode, props, className, ...rest
}) => {
    const { status, error, properties, draftText } = useHeadingProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Heading
            </Badge>
            <Heading
                {...properties} as={AsComponent}
                className={className}
                iconClassName="me-1"
                heading={draftText}>
                {children}
            </Heading>
        </div>)
}

